import {Polygon} from "./Polygon";

export class GLModel{
    vbo;
    ibo;
    indexCount;
    constructor(vertices:Array<number>,indices:Array<number>,gl:WebGLRenderingContext) {
        this.vbo = Polygon.CreateVBO(vertices,gl);
        this.ibo = Polygon.CreateIBO(indices,gl);
        this.indexCount = indices.length;
    }
    Update(vertices:Array<number>,indices:Array<number>,gl:WebGLRenderingContext){
        gl.bindBuffer(gl.ARRAY_BUFFER,this.vbo);
        gl.bufferSubData(gl.ARRAY_BUFFER,0,new Float32Array(vertices));
        gl.bindBuffer(gl.ARRAY_BUFFER,null);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,this.ibo);
        gl.bufferSubData(gl.ELEMENT_ARRAY_BUFFER,0,new Int16Array(indices));
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,null);
        this.indexCount = indices.length;

    }
}